import React from "react"
import { Route, Redirect } from "react-router-dom"

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = localStorage.getItem("token")
  console.log("this", isAuthenticated)

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

export default ProtectedRoute
